module.exports = __webpack_public_path__ + "img/prize_l@2x.d5e3b6d6.png";